var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:{ 'homepage-v23': _vm.isHome },attrs:{"id":"app"}},[_c('Header'),(_vm.isHome)?_c('HomeBanner'):_vm._e(),_c('router-view'),(_vm.isHome)?_c('StickyPlayer',{attrs:{"showPlayer":_vm.showPlayer || _vm.isPlaying}}):_vm._e(),_c('AnalyticsConsent')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }